export const ROUTES = {
  OVERVIEW: "/overview",
  HOME: "/Home",
  DASHBOARD_SUMMARY: "/dashboard-summary",
  NOC_DASHBOARD: "/noc-dashboard",
  PLANT_DASHBOARD: "/plant-dashboard",
  REPORT: "/report",
  OPERATIONS_CUSTOMERS: "/operations/customers",
  OPERATIONS_CUSTOMERS_360: "/operations/customers-360",
  OPERATIONS_PLANT_360: "/operations/plant-360",
  OPERATIONS_TARIFFS: "/operations/tariffs",
  OPERATIONS_TARIFFS_V2: "/operations/tariffs-v2",
  OPERATIONS_PLANT_HEALTH: "/operations/plant-health",
  OPERATIONS_RECHARGE: "/operations/recharge",
  OPERATIONS_METERS: "/operations/meters",
  OPERATIONS_IOT: "/operations/iot",
  OPERATIONS_EXEC_TRANSACTIONS: "/operations/exec-transactions",
  OPERATIONS_MAINTENANCE: "/operations/maintenance",
  OPERATIONS_ELECTRICIAN_COMPLAINTS: "/operations/electrician-complaints",
  OPERATIONS_DG_TRACKING: "/operations/dg-tracking",
  OPERATIONS_REVENUE_TARGET: "/operations/revenue-target",
  OPERATIONS_INVENTORY: "/operations/inventory",
  OPERATIONS_BIOMASS_MAINTENANCE: "/operations/biomass-maintenance",
  FINANCE_IN_PROGRESS: "/finance/in-progress",
  FINANCE_TRANSACTIONS: "/finance/transactions",
  FINANCE_DEPOSIT: "/finance/deposit",
  FINANCE_EXPENSES: "/finance/expenses",
  FINANCE_BUDGET: "/finance/budget",
  FINANCE_METER_DETAILS: "/finance/meter-details",
  CRM_KYC: "/crm/kyc",
  CRM_COMPLAINTS: "/crm/complaints",
  CRM_SURVEY: "/crm/survey",
  PAYSTACK_TRANSACTIONS: "/paystack/transactions",
  ACCESS_USERS: "/access/users",
  ACCESS_ROLES: "/access/roles",
  ACCESS_PERMISSIONS: "/access/permissions",
  ACCESS_PERMISSION_CATEGORIES: "/access/permission-categories",
  ACCESS_LIST: "/access/list",
  ADMIN_GEN_POTENTIAL: "/admin/gen-potential",
  ADMIN_PLANTS: "/admin/plants",
  ADMIN_PIPELINE: "/admin/pipeline",
  ADMIN_POLES: "/admin/poles",
  ADMIN_COUNTRY: "/admin/country",
  ADMIN_STATES: "/admin/states",
  ADMIN_NOC: "/admin/noc",
  ADMIN_BLOCK_RATE: "/admin/block-rate",
  ADMIN_TOU: "/admin/tou",
  ADMIN_TEMPLATE: "/admin/template",
  ADMIN_CAMPAIGN: "/admin/campaign",
  ADMIN_MANUAL_CASH: "/admin/manual-cash",
  ADMIN_TICKET: "/admin/ticket",
  ADMIN_OPS_SUMMARY: "/admin/ops-summary",
  ADMIN_CUSTOMER_SUMMARY: "/admin/customer-summary",
  ADMIN_FINANCE_SUMMARY: "/admin/finance-summary",
  ADMIN_EMPLOYEES: "/admin/employees",
  ADMIN_INVENTORY_CONFIG: "/admin/inventory-config",
  ADMIN_NIGERIASMSDASHBOARD: "/admin/nigeria-sms-dashboard",
  // FMS Admin Modules
  ADMIN_FMS_DASHBOARD: "/admin/fms-dashboard",
  ADMIN_FMS_ASE: "/admin/fms-ase",
  ADMIN_FMS_ASE_DASHBOARD: "/admin/fms-ase/dashboard",
  ADMIN_FMS_ASE_APPROVAL: "/admin/fms-ase/approval",
  ADMIN_FMS_TASK_MANAGEMENT: "/admin/fms-task-management",
  ADMIN_FMS_POLE_MANAGEMENT: "/admin/fms-pole-management",
  ADMIN_FMS_TRAVEL_MANAGEMENT: "/admin/fms-travel-management",
  ADMIN_FMS_INVENTORY_MANAGEMENT: "/admin/fms-inventory-management",
  ADMIN_FMS_DRAG_DOWN_CONFIGURATION: "/admin/fms-drag-down-configuration",
  ADMIN_FMS_NOTIFICATIONS: "/admin/fms-notifications",
  ADMIN_FMS_EXPENSE: "/admin/fms-expense",
  ADMIN_FMS_EMPLOYEE_ADVANCE_LIMITS: "/admin/fms-employee-advance-limits",
  SALES_PRODUCTS: "/sales/products",
  SALES_DISCOUNTS: "/sales/discounts",
  SALES_AGENTS: "/sales/agents",
  SALES_COMMISSIONS: "/sales/commissions",
  SALES_PRODUCT_PIPELINE: "/sales/product-pipeline",
  SALES_CUSTOMER_PIPELINE: "/sales/customer-pipeline",
  SALES_EXECUTIVE_TRACKING: "/sales/executive-tracking",
  AGENTS_CUSTOMERS: "/agents/customers",
  AGENTS_RECHARGE: "/agents/recharge",
  AGENTS_TARIFF_CHANGE: "/agents/tariff-change",
  AGENTS_DASHBOARD: "/agents/dashboard",
  AGENTS_CREDIT: "/agents/credit",
  LOGS_SYSTEM: "/logs/system",
  LOGS_API: "/logs/api",
  LOGS_ACTIVITY: "/logs/activity",
  LOGS_LOG_TIME: "/logs/log-time",
  // Reports
  REPORTS_TABLE: "/reports",
  // Add more as needed
  ADD_METER: "/add-Meter",
  METER: "/meters",
  EDIT_METER: "/edit-meter/:meterSerial/:meterState/:meterId",
  ADD_METER_V1: "/admin/add-meter-v1",
  EDIT_METER_V1: "/admin/edit-sparkmeter/:meterId",
  FORBIDDEN: "/403-Forbidden",
  VIEW_METERWIP_V1: "/admin/view-sparkmeterwip/:meterId",
  CHANGE_METER: "/customer/meter-change/:customerId",
  CUSTOMER_360: "/customer360",
  OPERATION_RECHARGE: "/agent-customer-recharge",
  MANUAL_CASH_PAYMENTS_IMPORT: "/bulk-bonus/manual-cash-payments-import",
  TRANSACTIONS: "/finance/transactions",
  VIEW_TRANSACTIONS: "/finance/transactions/view/:transactionId/:type",
  FMS: "/fms",
  FMS_MODULES: "/fms-modules",
  Ugx: "/Ugx",
  CASH_PAYMENTS: "/payments/cash-payments",
  WIP_TRANSACTIONS: "/finance/wip-transactions",
};

